//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';

function Page() {
  const children = useStore((state) => state.children);
  const setChildren = useStore((state) => state.setChildren);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.children.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={children}
          onChange={(value) => {
            setChildren(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'children',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'Yes, we live together'}>
            <span>👨‍👩‍👧</span> {t('onboarding.children.options.yes')}
          </Option>
          <Option value={'Yes, but we live separately'}>
            <span>👨‍👧</span> {t('onboarding.children.options.liveSeparately')}
          </Option>
          <Option value={'No, I don’t have kids'}>
            <span>🚫</span> {t('onboarding.children.options.no')}
          </Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
